module.exports = __webpack_public_path__ + "4239432d018364eab7726a853cbe8465.svg";